import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.605 2.107a10 10 0 1 1-4.147 18.227 1 1 0 1 1 1.108-1.665A8 8 0 1 0 6.318 6.375L3.474 9H7a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v3.64l2.948-2.722a10 10 0 0 1 5.657-2.811M13 7a1 1 0 1 0-2 0v6a1 1 0 0 0 .553.894l4 2a1 1 0 1 0 .894-1.788L13 12.382z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }